import { SystemAuthorizations } from 'shell/authorizations/system';
import { HeadCell } from 'shell/components/shared/table/types';
import { ForeignStateClient } from './types';
import * as yup from 'yup';
import { regexAcronymState } from 'system/geographic/components/state/constants';

export const authsObj = Object.freeze({
  read: [SystemAuthorizations.StatoesteroQuery],
  create: [SystemAuthorizations.StatoesteroAdd],
  edit: [SystemAuthorizations.StatoesteroUpdate],
  delete: [SystemAuthorizations.StatoesteroDelete],
});

export const headCells: HeadCell<ForeignStateClient, keyof ForeignStateClient>[] = [
  {
    id: 'code',
    label: 'Codice',
  },
  {
    id: 'acronym',
    label: 'Sigla stato',
  },
  {
    id: 'name',
    label: 'Nome stato',
  },
  {
    id: 'action',
    label: '',
  },
];

export const validationSchemaStateFilter = yup.object({
  acronym: yup
    .string()
    .min(1, 'Il campo stato deve essere almeno di 1 caratteri')
    .max(3, 'Il campo stato deve essere al massimo di 3 caratteri')
    .matches(regexAcronymState, 'Il campo sigla stato deve essere es: ci oppure ci*'),
  code: yup.string(),
  name: yup.string(),
});
